import config from 'shared/config';
import ErrorBoundary from 'shared/components/ErrorBoundary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion  from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';

import styles from './styles.css';

/**
 * Handle display of sku of a given product
 * @param {React props} props
 */
const Sku = props => {
	const { ShowSku } = config.PRODUCT;
	const { isSoftkit, selectedComponents, sku } = props;

	return ShowSku && sku != null ? (
		<ErrorBoundary>
			<div className={styles['product-expandable-spacer']}>
				<Accordion>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography variant="subtitle2">SKU</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<div className={styles['product-sku']}>
							<h5 className={styles['product-sku-header']}>{sku}</h5>
							{isSoftkit ? (
								<div>
									{selectedComponents.map(item => (
										<li key={item.id}>
											<span style={{ fontWeight: 'bold' }}>{item.name}: </span>
											{item.sku}
										</li>
									))}
								</div>
							) : null}
						</div>
					</AccordionDetails>
				</Accordion>
			</div>
		</ErrorBoundary>
	) : null;
};

Sku.propTypes = {
	selectedComponents: PropTypes.arrayOf(PropTypes.object).isRequired,
	sku: PropTypes.string,
	isSoftkit: PropTypes.bool.isRequired,
};

Sku.defaultProps = {
	sku: null,
};

export default Sku;
